import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ignoreInterceptorHeaders } from '@rx-applications/shared/utils';
import { CidStorageService } from '../services/cid-storage.service';

@Injectable({ providedIn: 'root' })
export class CidInterceptor implements HttpInterceptor {
  #cidStorageService = inject(CidStorageService);

  /* eslint-disable @typescript-eslint/no-explicit-any */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.headers.has(ignoreInterceptorHeaders.ignoreCid)) {
      const requestClone = req.clone({
        headers: req.headers.delete(ignoreInterceptorHeaders.ignoreCid),
      });
      return next.handle(requestClone);
    }

    const cid = this.#cidStorageService.getOrGenerateCID();
    const reqClone = cid.length > 0 ? req.clone({ setHeaders: { 'Rx-CID': cid } }) : req;
    return next.handle(reqClone);
  }
}
